import React from 'react'
import { CSSTransition } from 'react-transition-group'

import TrailProfile from './TrailProfile'
import UserPositionControl from './UserPositionControl'

import { useUrlParams } from '../hooks'
import { useIsMobile, useHaveInfoPanel } from '../slices/ui'
import { useSettings  } from '../slices/settings'

const ProfileView = (props) => {
  const { route_id, trail_id, accommodationList } = useUrlParams()
  const { unit, speed } = useSettings()
  const compact = useIsMobile()
  const infoPanel = useHaveInfoPanel()
  const showProfile = trail_id && !infoPanel && !accommodationList

  return (
    <CSSTransition in={showProfile} unmountOnExit timeout={1000} classNames="pwa__mappanel__profile__container">
      <div className="pwa__mappanel__profile__container">
        { compact && <UserPositionControl/> }
        <TrailProfile route_id={route_id} trail_id={trail_id} compact={compact} unit={unit} speed={speed} />
      </div>
    </CSSTransition>
  )
}

export default ProfileView;
